<template>
	<div v-loading="dataLoading" v-if="data">
		<div class="page-group-title"><span>{{ data.createTime }}用户发起售后</span> {{ status.get(data.status) }}</div>
		<table v-if="data" class="info-table MT20" width="100%">

			<tr>
				<th>售后类型</th>
				<td>{{ data.type == 1 ? '发货前 - 申请修改收货地址' : data.type == 2 ? '发货前 - 申请取消商品 ' : '发货后 - 申请退货' }}</td>
			</tr>
			<tr>
				<th>订单编号</th>
				<td>{{ data.orderSn }}</td>
			</tr>
			<tr v-if="data.reason">
				<th>售后原因</th>
				<td>{{ data.reason }}</td>
			</tr>
			<tr v-if="data.orderRemark">
				<th>订单备注</th>
				<td>{{ data.orderRemark }}</td>
			</tr>
			<tr v-if="data.additionalInstructions">
				<th>用户补充</th>
				<td>{{ data.additionalInstructions }}</td>
			</tr>
			<tr v-if="data.photo && data.photo.length > 0">
				<th></th>
				<td>
					<template v-for="(item, index) in data.photo">
						<el-image :src="item" :key="index" fit="cover" :preview-src-list="data.photo"></el-image>
					</template>
				</td>
			</tr>
			<tr v-if="data.goodsInfo && data.goodsInfo.length > 0">
				<th>商品</th>
				<td>
					<template v-for="(item, index) in data.goodsInfo" :index="index">
						<div class="MT10">{{ item.key }}<span class="color-danger">（{{ item.value }}）</span></div>
					</template>
				</td>
			</tr>
			<tr>
				<th>购买人</th>
				<td>{{ data.userInfo }}</td>
			</tr>
			<template v-if="data.type == 1">
				<tr>
					<th>原收货信息</th>
					<td>{{ data.backAddress }}</td>
				</tr>
				<tr class="color-danger">
					<th>新收货信息</th>
					<td>{{ data.address }}</td>
				</tr>
			</template>
			<template v-if="data.type == 2 || data.type == 3">
				<tr>
					<th v-if="data.type == 2">可取消数量</th>
					<th v-if="data.type == 3">可退货数量</th>
					<td>{{ data.canNum }}</td>
				</tr>
				<tr class="color-danger">
					<th v-if="data.type == 2">申请取消数量</th>
					<th v-if="data.type == 3">申请退货数量</th>
					<td>{{ data.num }}</td>
				</tr>
			</template>
		</table><!-- 0:待审核 1:已拒绝 2:待退货 3:待收货 4:待退款 5:已关闭  -->
		<template v-if="data && data.type == 1 && data.status == 5">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<span>{{ item.createTime }}更新收货地址,售后关闭</span></div>
		</template>
		<template v-if="data.status == 1">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<template v-if="item.status == 1">
					<span>{{ item.createTime }} 拒绝</span>
					<div class="color-danger MT10" v-if="item.info">备注： {{ item.info }}</div>
				</template>
			</div>
		</template>
		<template v-if="data.status == 3 && data.type != 3">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.info">{{ item.info }}</div>
			</div>
		</template>
		<template v-if="data.status == 4 && data.type == 2">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 4">{{ item.createTime }} 确认取消,等待退款</div>
			</div>
		</template>
		<template v-if="data.status == 5 && data.type == 2">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 5">{{ item.createTime }} 退款完成，售后关闭</div>
			</div>
		</template>

		<template v-if="data.type == 3 && data.status == 2">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 2">{{ item.createTime }} 确认退货,等待用户寄回</div>
			</div>
		</template>
		<template v-if="data.type == 3 && data.status == 3">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 3">{{ item.createTime }}
					用户寄回,等待确认收货<br>快递信息：{{ item.info }}</div>
				<div class="color-danger MT10" v-if="item.status == 2">{{ item.createTime }} 确认退货,等待用户寄回</div>
			</div>
		</template>
		<template v-if="data.type == 3 && data.status == 4">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 3">{{ item.createTime }}
					用户寄回,等待确认收货<br>快递信息：{{ item.info }}</div>
				<div class="color-danger MT10" v-if="item.status == 2">{{ item.createTime }} 确认退货,等待用户寄回</div>
				<div class="color-danger MT10" v-if="item.status == 4">{{ item.createTime }} 确认收货,等待退款</div>
			</div>
		</template>
		<template v-if="data.type == 3 && data.status == 5">
			<div class="page-group-title" v-for="(item, index) in data.logs" :index="index">
				<div class="color-danger MT10" v-if="item.status == 3">{{ item.createTime }}
					用户寄回,等待确认收货<br>快递信息：{{ item.info }}</div>
				<div class="color-danger MT10" v-if="item.status == 2">{{ item.createTime }} 确认退货,等待用户寄回</div>
				<div class="color-danger MT10" v-if="item.status == 4">{{ item.createTime }} 确认收货,等待退款</div>
				<div class="color-danger MT10" v-if="item.status == 5">{{ item.createTime }} 退款完成，售后关闭</div>
			</div>
		</template>

		<div class="btns MT20">
			<el-button @click="goBack">返回</el-button><!-- 0:待审核 1:已拒绝 2:待退货 3:待收货 4:待退款 5:已关闭  -->
			<template v-if="data.status != 5 && data.status != 1 && data.status != 4">
				<el-button type="danger" @click="drawerShow = true;">拒绝</el-button>
				<el-button type="primary" @click="pass(1)" v-if="data && data.type == 1">更新收货地址</el-button>
				<el-button type="primary" @click="pass(1)"
					v-if="data && data.type == 2 && data.status == 0 || (data.type == 3 && data.status == 3)"
					:loading="btnLoading">确认退货</el-button>
				<el-button type="primary" v-if="data.type == 3 && data.status == 0" @click="addressShow = true"
					:loading="btnLoading">确认退货</el-button>
			</template>
		</div>

		<!-- 审核 -->
		<el-drawer title="拒绝" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
			@close="close">
			<div class="drawer-content">
				<!-- <el-alert show-icon type="warning" :closable="false" :title="`是否确认${formData.status == 2 ? '通过审核' : '拒绝通过'}?`"></el-alert> -->
				<el-form :model="formData2" ref="formData2" label-position="top">
					<el-form-item prop="remark" label="拒绝需要填写理由备注:" :rules='[{ required: true, message: "请输入拒绝理由备注" }]'>
						<el-input v-model="formData2.remark" type="textarea" :rows="4" maxlength="100"
							show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="close">取消</el-button>
				<el-button type="danger" @click="submitForm(0)" :loading="btnLoading">确认拒绝</el-button>
			</div>
		</el-drawer>
		<!-- 发货后 - 申请退货 待审核 地址弹框 -->
		<el-drawer title="确认退货" :visible.sync="addressShow" :wrapperClosable="false" :destroy-on-close="true"
			size="auto" @close="close">
			<div class="drawer-content">
				<el-form :model="formData2" ref="formData2" label-position="top" :rules="rules">
					<el-row>
						<el-col :span="8">
							<el-form-item prop="addressType" label="确认允许用户退货,请填写此次用户寄回地址:">
								<el-radio-group v-model="addressType" size="medium" @change="changeAddresstype">
									<el-radio v-model="addressType" :label="1">【到付拒收】北京市 朝阳区
										莱锦文化创意园CN07，李先生，15201388050</el-radio>
									<el-radio v-model="addressType" :label="2" class="MT10">【顺丰陆运包裹到付】北京市 朝阳区
										莱锦文化创意园CN07，李先生，15201388050</el-radio>
									<el-radio v-model="addressType" :label="3" class="MT10">【到付拒收】浙江省 义乌市
										云远电商园3号楼5层，李先生，15201388050</el-radio>
									<el-radio v-model="addressType" :label="4" class="MT10">浙江省 杭州市
										萧山区春潮路7号春光明美家具公司1号楼4楼408，芳芳，15037062881</el-radio>
									<el-radio v-model="addressType" :label="5" class="MT10">自定义地址</el-radio>
									<el-radio v-model="addressType" :label="6" class="MT10">四川省 成都市
										青羊区头福街66号城投置地文园5楼，胡婷，18181426183</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-if="addressType == 5">
						<el-col :span="12">
							<el-form-item prop="customUserName" label="收货人姓名:">
								<el-input v-model.trim="formData2.customUserName" placeholder="请输入收货人姓名" maxlength="20"
									size="medium"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item prop="telephone" label="联系手机:">
								<el-input class="input-with-select" v-model.trim="formData2.telephone"
									placeholder="请输入联系手机" maxlength="20" size="medium" s></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item prop="city" label="收货省市:">
								<el-cascader v-model="formData2.city" :options="cityList" filterable
									:props="{ label: 'name', children: 'cityList', value: 'name' }" size="medium"
									style="width:100%" ref="cityCascader" @change="changeCity">
								</el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item prop="address" label="收货地址:">
								<el-input v-model.trim="formData2.address" placeholder="请输入收货地址" maxlength="100"
									size="medium"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<div class="drawer-footer">
						<el-button @click="addressShow = false">取消</el-button>
						<el-button type="primary" @click="addressForm()" :loading="btnLoading">确认退货</el-button>
					</div>
				</el-form>
			</div>

		</el-drawer>
	</div>
</template>

<script>
import { fetchAllCity, fetchAllCountry } from '@/assets/js/commonApi';


export default {
	props: {
		id: {
			type: [Number, String],
			default: ''
		}
	},
	data() {
		return {
			dataLoading: false,
			data: null,
			redirect: this.$route.query.redirect,
			drawerShow: false,
			addressShow: false,
			formData: null,
			formData2: {
				remark: '',//拒绝理由
				address: '',
				cityName: '',
				customUserName: '',
				provinceName: '',
				telephone: '',
				city: [],
			},
			// formData2:{},
			addressType: 5,
			btnLoading: false,
			countryList: [],
			cityList: [],

			remark: '',
			address: '',
			cityName: '',
			customUserName: '',
			provinceName: '',
			telephone: '',
			rules: {
				address: [{ required: true, message: "请输入收货地址", trigger: "blur" }],
				customUserName: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
				telephone: [
					{ required: true, message: "请输入联系手机" },
					{ validator: this.$utils.validatePhone },
				],
				city: [{ required: true, message: '请输入收货省市', trigger: 'blur' }],
			},
		}


	},
	computed: {

		status() {
			return new Map([
				[0, '待审核'],
				[1, '已拒绝'],
				[2, '待退货'],
				[3, '待收货'],
				[4, '待退款'],
				[5, '已关闭']
			])
		}
	},
	mounted() {
		this.getData();
		this.getCityList();
		this.getCountryList();
	},
	methods: {
		//获取所有城市
		async getCityList() {
			const res = await fetchAllCity({}).catch(() => { });
			const { state, result } = res.data;
			if (state == 1) {
				this.cityList = result;
			}
		},
		//获取所有国家（区号）
		async getCountryList() {
			const res = await fetchAllCountry({}).catch(() => { });
			const { state, result } = res.data;
			if (state == 1) {
				this.countryList = result;
			}
		},
		//选择城市
		changeCity(value) {
			this.formData2.provinceName = value ? value[0] : '';
			this.formData2.cityName = value ? value[1] : '';
		},
		changeAddresstype(val) {
			if (val != 3) {
				this.formData2.customUserName = ''
				this.formData2.cityName = ''
				this.formData2.provinceName = ''
				this.formData2.address = ''
				this.formData2.telephone = ''
			}
		},
		getData() {
			this.dataLoading = true
			this.$request({
				url: "/goodsAfterSale/detail",
				method: "POST",
				params: {
					id: this.id
				},
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1 && result) {
						this.data = result;
						//this.data.photo = this.data.photo ? this.data.photo.split(',') : [];
					} else {
						this.$message.error(msg || "请求失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})
				.finally(() => {
					this.dataLoading = false;
				});
		},
		//返回
		goBack() {
			if (this.redirect) {
				this.$router.push({
					path: this.redirect,
				});
			} else {
				this.$router.go(-1);
			}
		},

		close() {
			this.drawerShow = false;
		},
		//审核通过的
		pass(type) {
			var _type = type
			this.btnLoading = true;

			this.$request({
				url: '/goodsAfterSale/audit',
				method: "POST",
				params: { type: _type, id: this.id },
			})
				.then((res) => {
					//处理成功回调
					const { state, msg } = res.data;
					if (state && state == 1) {
						this.btnLoading = false;
						this.$message.success("操作成功");
						this.close();
						this.getData();
					} else {
						return this.$message.error(msg || "操作失败");
					}
				})
				.finally(() => {
					this.btnLoading = false;
				});
		},
		addressForm() {
			// - 北京市 朝阳区 莱锦文化创意园CN07，李先生，15201388050
			// - 浙江省 义乌市 云远电商园3号楼5层，李先生，15201388050
			// - 浙江省 杭州市 萧山区春潮路7号春光明美家具公司1号楼4楼408，芳芳，15037062881
			// - 四川省 成都市 青羊区头福街66号城投置地文园5楼，胡婷，18181426183
			if (this.addressType == 1) {
				this.formData = {
					customUserName: '【到付拒收】李先生',
					cityName: '北京',
					address: '朝阳区莱锦文化创意园CN07',
					telephone: '15201388050',
					type: 1,
					id: this.id
				}
			} else if (this.addressType == 2) {
				this.formData = {
					customUserName: '【顺丰陆运包裹到付】李先生',
					cityName: '北京',
					address: '朝阳区莱锦文化创意园CN07',
					telephone: '15201388050',
					type: 1,
					id: this.id
				}
			} else if (this.addressType == 3) {
				this.formData = {
					customUserName: '李先生',
					cityName: '义乌市',
					provinceName: '浙江',
					address: '云远电商园3号楼5层',
					telephone: '15201388050',
					type: 1,
					id: this.id
				}
			} else if (this.addressType == 4) {
				this.formData = {
					customUserName: '芳芳',
					cityName: '杭州市',
					provinceName: '浙江',
					address: '萧山区春潮路7号春光明美家具公司1号楼4楼408',
					telephone: '15037062881',
					type: 1,
					id: this.id
				}
			} else if (this.addressType == 6) {
				this.formData = {
					customUserName: '胡婷',
					cityName: '成都市',
					provinceName: '四川',
					address: '青羊区头福街66号城投置地文园5楼',
					telephone: '18181426183',
					type: 1,
					id: this.id
				}
			} else {
				this.formData = {
					customUserName: this.formData2.customUserName,
					cityName: this.formData2.cityName,
					provinceName: this.formData2.provinceName,
					address: this.formData2.address,
					telephone: this.formData2.telephone,
					type: 1,
					id: this.id
				}
			}

			this.$refs["formData2"].validate((valid) => {
				if (valid) {

					this.btnLoading = true;
					this.$request({
						url: "/goodsAfterSale/audit",
						method: "POST",
						params: { ...this.formData, type: 1, id: this.id },
					})
						.then((res) => {
							//处理成功回调
							const { state, msg } = res.data;
							if (state && state == 1) {
								this.btnLoading = false;
								this.$message.success("操作成功");
								this.addressShow = false
								this.getData();
							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.btnLoading = false;
						});
				}
			});


		},
		//审核
		submitForm(type) {

			var _type = type
			this.$refs["formData2"].validate((valid) => {
				if (valid) {
					this.btnLoading = true;
					this.$request({
						url: '/goodsAfterSale/audit',
						method: "POST",
						params: { type: _type, id: this.id, remark: this.formData2.remark },
					})
						.then((res) => {
							//处理成功回调
							const { state, msg } = res.data;
							if (state && state == 1) {
								this.btnLoading = false;
								this.$message.success("操作成功");
								this.$refs['formData2'].clearValidate();
								this.$refs['formData2'].resetFields();
								this.close();
								this.getData();
							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.btnLoading = false;
						});
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.info-table {
	th {
		width: 140px;
	}

	td {
		.el-image {
			width: 200px;
			height: 120px;
			margin: 5px;
			background: #f8f8f8;

			&.userAvatar {
				width: 150px;
				height: 150px;
			}
		}
	}
}
</style>